import React from "react";
import Header from "../comp/Header";
import About from "../comp/About";
import PortfolioComp from "../comp/portfolio/PortfolioComp";
import Blogs from "../comp/Blogs";
import Skills from "../comp/Skills";
import Footer from "../comp/Footer";
import Achive from "../comp/Achive";
import Funfact from "../comp/Funfact";

const Portfolio = () => {
  return (
    <>
      <Header />
      <About />
      <PortfolioComp />
      <Achive />
      <Funfact />
      <Skills />
      <Blogs />
      <Footer />
    </>
  );
};

export default Portfolio;
